import Legend from 'components/molecules/Legend';
import { colorConstants } from 'config/colorConstants';
import { promoRecommendation } from 'contexts/PromoRecommendationContext';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { CustomTable, tableHeight } from './SummarySection';
import { getPlaybookColumns } from 'utils/getRecommendationTableColumns';
import { useFetchPlaybookData } from 'hooks/promoRecommendation/useFetchPlaybook';
import { getConfig } from 'utils/helperMethods';
import { UserContext } from 'contexts/ConfigContext';
import { newPlanValue } from 'hooks/promoRecommendation/useFetchGetPlans';
import Button from 'components/atoms/Button';
import { FilterContextData } from 'contexts/FilterContext';

const legendItems = [
    {
        label: 'Compliant',
        color: colorConstants.limeGreen,
        style: { borderRadius: 2 },
    },
    {
        label: 'Non-Compliant',
        color: colorConstants.red,
        style: { borderRadius: 2 },
    },
];

const emptyText = 'Please select a Scenario from the recommendations page in order to view the Playbook';

interface PlaybookSectionProps {
    isToggled: boolean;
    setIsToggled: (value: boolean) => void;
    roi: number;
    setRoi: (value: number) => void;
    ts: number;
    setTs: (value: number) => void;
    frequency1: number;
    sefrequency1: (value: number) => void;
    frequency2: number;
    sefrequency2: (value: number) => void;
    userEmail: string | null;
    editAccessRoll: object;
}
const PlaybookSection = ({
    isToggled,
    setIsToggled,
    roi,
    setRoi,
    ts,
    setTs,
    frequency1,
    sefrequency1,
    frequency2,
    sefrequency2,
    userEmail,
    editAccessRoll,
}: PlaybookSectionProps) => {
    const { appConfig } = useContext(UserContext);
    const { selectedPlan } = useContext(promoRecommendation);
    const promoRecommendationConfig = getConfig('promoRecommendation', appConfig);
    const { currentFrequency } = useContext(FilterContextData);
    const {
        data: playbookData,
        loading: playbookLoading,
        error: playbookError,
        fetchPlaybookData,
        setData,
    } = useFetchPlaybookData();

    useEffect(() => {
        if (selectedPlan?.value !== newPlanValue)
            fetchPlaybookData({
                variables: {
                    planId: selectedPlan?.planId,
                    limit: promoRecommendationConfig?.playbookLimit,
                    frequency: currentFrequency?.key,
                    offset: 0,
                },
            });
    }, [selectedPlan]);

    const toggle = () => {
        setIsToggled(!isToggled); // directly update the state
        localStorage.setItem(
            'playbookKpiValues',
            JSON.stringify({
                ...JSON.parse(localStorage.getItem('playbookKpiValues') || '{}'),
                GuidelinesFrequency1: frequency1,
                GuidelinesFrequency2: frequency2,
                GuidelinesTS: ts,
                GuidelinesROI: roi,
            }),
        );
    };

    const tableColumns = useMemo(() => {
        if (playbookData)
            return getPlaybookColumns(
                playbookData,
                isToggled,
                setIsToggled,
                roi,
                setRoi,
                ts,
                setTs,
                frequency1,
                sefrequency1,
                frequency2,
                sefrequency2,
                userEmail,
                editAccessRoll,
                setData,
            );
    }, [playbookData, isToggled, roi, ts, frequency1, frequency2, userEmail, editAccessRoll]);
    return (
        <div>
            {selectedPlan?.value !== newPlanValue ? (
                <>
                    <div className="flex justify-between">
                        <p className="font-sm text-promoColour">SRM Guidelines vs {selectedPlan?.label || ''}</p>
                        <div className="flex justify-between">
                            <Legend className="legend-size-square" data={legendItems} />
                            {Object.keys(editAccessRoll).includes(userEmail || 'null') && (
                                <Button
                                    style={{ height: '24px', marginLeft: '20px' }}
                                    title={isToggled ? 'Edit' : 'Save'}
                                    onClick={toggle}
                                />
                            )}
                        </div>
                    </div>
                    <div className="mt-4">
                        <CustomTable
                            loading={playbookLoading}
                            //bordered
                            pagination={false}
                            scroll={{ x: '100%', y: tableHeight }}
                            sticky
                            columns={tableColumns}
                            dataSource={playbookData}
                        />
                    </div>
                </>
            ) : (
                <div
                    className="flex font-md justify-center items-center text-borderGrey"
                    style={{ height: tableHeight }}
                >
                    {emptyText}
                </div>
            )}
        </div>
    );
};

export default PlaybookSection;
